// useAuth.js
import { useSelector } from 'react-redux'
import { selectCurrentToken } from "../features/auth/authSlice"
import jwtDecode from 'jwt-decode'

const useAuth = () => {
    const token = useSelector(selectCurrentToken)

    if (!token) {
        return {
            userId: '',
            username: '',
            displayname: '',
            platformRoles: [],
            appAssignments: [],
            accessibleApps: [],
            isGlobalAdmin: false,
        }
    }

    const decoded = jwtDecode(token)
    const userInfo = decoded?.UserInfo || {}

    const {
        userId,
        username,
        displayname,
        platformRoles = [],
        appAssignments = []
    } = userInfo

    const isGlobalAdmin = platformRoles.includes('GLOBAL_ADMIN')

    // derive accessible apps
    const accessibleApps = isGlobalAdmin
        ? ['ALL'] // you can later map this to full menu list
        : appAssignments.map(a => a.app)

    // helper: get app access
    const getAppAccess = (appName) => {
        if (isGlobalAdmin) {
            return {
                app: appName,
                roles: ['GLOBAL_ADMIN'],
                scope: {}
            }
        }

        return appAssignments.find(a => a.app === appName) || null
    }

    // helper: check role inside app
    const hasAppRole = (appName, role) => {
        if (isGlobalAdmin) return true

        const appAccess = getAppAccess(appName)
        return appAccess?.roles?.includes(role) || false
    }

    console.log("Decoded JWT:", decoded)

    return {
        userId,
        username,
        displayname,

        platformRoles,
        appAssignments,

        isGlobalAdmin,
        accessibleApps,

        getAppAccess,
        hasAppRole
    }
}

export default useAuth